import { throttle } from 'lodash';

/**
 * ページ読み込み時の初期設定
 */
export function headerConfig() {
  window.addEventListener('DOMContentLoaded', () => {
    // const headerSpSubEle = document.querySelector('.js-headerSpSub');
    const headerSpSubItems = document.querySelectorAll('.js-headerSpSub .js-headerSubItem');

    for (let i = 0; i < headerSpSubItems.length; i++) {
      headerSpSubItems[i].setAttribute('tabindex', '-1');
    }
  });
}

/**
 * メガメニューの展開処理
 */
export function megaMenuToggle() {
  const IS_ACTIVE = 'is-active';
  const IS_VIEW = 'is-view';
  const menuTextAll = document.querySelectorAll('.js-headerMegaText');
  const menuAll = document.querySelectorAll('.js-headerMega');
  const menuItems = document.querySelectorAll('.js-headerMegaItem');

  window.addEventListener(
    'resize',
    _.throttle(
      (e) => {
        megaMenuAction();
        return false;
      },
      100,
      { trailing: true, leading: true }
    )
  );

  megaMenuAction();

  function megaMenuAction() {
    let currentWidth = window.innerWidth;
    const hamburgerEle = document.querySelector('.js-headerHamburger');

    if (currentWidth > 999) {
      const headerMegaTriggerAll = document.querySelectorAll('.js-headerMegaTrigger');
      const headerMegaEleAll = document.querySelectorAll('.js-headerMega');

      hamburgerEle.setAttribute('tabindex', '-1');

      headerMegaTriggerAll.forEach((target) => {
        const targetChild = target.firstElementChild;

        target.addEventListener('click', () => {
          megaMenuConfig(target);
        });

        // target.addEventListener('mouseleave', () => {
        //   megaMenuConfig(target);
        // });

        targetChild.addEventListener('focus', () => {
          if (!targetChild.classList.contains('js-headerMegaText')) {
            menuStateReset();
          }
        });
      });

      // menuTextAll.forEach((target) => {
      //   target.addEventListener('focus', () => {
      //   });
      // });

      menuTextAll.forEach((menuText) => {
        menuText.addEventListener('focus', () => {
          // 全てのメガメニューを閉じる
          menuStateReset();
        });

        // menuText.addEventListener('blur', () => {
        //   if (!menuText.parentNode.nextElementSibling.querySelector('.js-headerMegaText')) {
        //     menuStateReset();
        //     // menuText.parentNode.nextElementSibling.firstElementChild.focus();
        //   }
        // });
      });
    } else {
      hamburgerEle.setAttribute('tabindex', '0');
    }
  }

  function menuStateReset() {
    menuTextAll.forEach((menuText) => {
      menuText.setAttribute('aria-expanded', 'false');
      // menuText.setAttribute('aria-hidden', 'true');

      menuText.classList.remove(IS_ACTIVE);
    });

    menuAll.forEach((menu) => {
      menu.classList.remove(IS_VIEW);
    });

    menuItems.forEach((menuItem) => {
      menuItem.setAttribute('tabindex', '-1');
    });
  }

  function megaMenuConfig(target) {
    const targetMenuText = target.querySelector('.js-headerMegaText');
    const targetMenu = target.querySelector('.js-headerMega');
    const targetItems = target.querySelectorAll('.js-headerMegaItem');

    if ('true' !== targetMenuText.getAttribute('aria-expanded')) {
      // 全てのメガメニューを閉じる
      menuStateReset();

      // 選択しているメガメニューを開く
      targetMenuText.setAttribute('aria-expanded', 'true');
      // targetMenuText.setAttribute('aria-hidden', 'false');

      targetMenuText.classList.add(IS_ACTIVE);
      targetMenu.classList.add(IS_VIEW);

      targetItems.forEach((item) => {
        item.setAttribute('tabindex', '0');
      });
    } else {
      // 開いているメガメニューを閉じる
      targetMenuText.setAttribute('aria-expanded', 'false');
      // targetMenuText.setAttribute('aria-hidden', 'true');

      targetMenuText.classList.remove(IS_ACTIVE);
      targetMenu.classList.remove(IS_VIEW);

      targetItems.forEach((item) => {
        item.setAttribute('tabindex', '-1');
      });
    }
  }
}

/**
 * ハンバーガーメニューの展開処理
 */
export function hamburgerToggle() {
  const hamburgerEle = document.querySelector('.js-headerHamburger');
  const headerCloseEle = document.querySelector('.js-headerClose');
  const headerSpMenuListAll = document.querySelectorAll('.js-headerSpMenuList');
  const headerSpEle = document.querySelector('.js-headerSp');
  const headerAcItems = document.querySelectorAll('.js-headerAcItem');
  const headerSubItemLast = document.querySelector('.js-headerSp .js-headerSubItemLast');
  const headerSpMegaItems = document.querySelectorAll('.js-headerSp js-headerMegaItem');
  const headerSpSubItems = document.querySelectorAll('.js-headerSp .js-headerSubItem');
  const translateEle = document.querySelector('.js-translate');
  const IS_TRANSLATE = 'is-translate';
  const IS_VIEW = 'is-view';

  hamburgerEle.addEventListener('click', () => {
    hamburgerEle.setAttribute('aria-expanded', 'true');
    translateEle.classList.add(IS_TRANSLATE);
    headerSpEle.classList.add(IS_VIEW);

    for (let i = 0; i < headerAcItems.length; i++) {
      headerAcItems[i].setAttribute('tabindex', '0');
    }

    for (let i = 0; i < headerSpMegaItems.length; i++) {
      headerSpMegaItems[i].setAttribute('tabindex', '0');
    }

    for (let i = 0; i < headerSpSubItems.length; i++) {
      headerSpSubItems[i].setAttribute('tabindex', '0');
    }

    headerCloseEle.focus();
  });

  headerSubItemLast.addEventListener('blur', () => {
    headerCloseEle.focus();
  });

  headerCloseEle.addEventListener('click', () => {
    translateEle.classList.remove(IS_TRANSLATE);
    headerSpEle.classList.remove(IS_VIEW);

    for (let i = 0; i < headerAcItems.length; i++) {
      headerAcItems[i].setAttribute('tabindex', '-1');
    }

    for (let i = 0; i < headerSpMegaItems.length; i++) {
      headerSpMegaItems[i].setAttribute('tabindex', '-1');
    }

    for (let i = 0; i < headerSpSubItems.length; i++) {
      headerSpSubItems[i].setAttribute('tabindex', '-1');
    }
  });

  headerSpMenuListAll.forEach((target) => {
    target.addEventListener('click', () => {
      translateEle.classList.remove(IS_TRANSLATE);
      headerSpEle.classList.remove(IS_VIEW);
    });

    for (let i = 0; i < headerAcItems.length; i++) {
      headerAcItems[i].setAttribute('tabindex', '-1');
    }

    for (let i = 0; i < headerSpMegaItems.length; i++) {
      headerSpMegaItems[i].setAttribute('tabindex', '-1');
    }

    for (let i = 0; i < headerSpSubItems.length; i++) {
      headerSpSubItems[i].setAttribute('tabindex', '-1');
    }
  });

  window.addEventListener(
    'resize',
    _.throttle(
      (e) => {
        headerSpRemoveClass();
        return false;
      },
      100,
      { trailing: true, leading: true }
    )
  );

  headerSpRemoveClass();

  function headerSpRemoveClass() {
    let currentWidth = window.innerWidth;

    if (currentWidth > 999) {
      translateEle.classList.remove(IS_TRANSLATE);
      headerSpEle.classList.remove(IS_VIEW);
    }
  }
}
